<template>
    <div v-if="isInited">
        <v-page-header
            title="输入框上方互动按钮"
            level="content"
        >
            <template slot="caption">
                同时对人工、大模型机器人接待生效
            </template>
            <template slot="extra">
                <v-switch
                    v-model="enableSwitch"
                    :label="enableSwitch?'已启用':'未启用'"
                />
            </template>
        </v-page-header>
        <div v-if="enableSwitch" class="section-item-line section-item-line__graybg nav-menu-section">
            <div class="section-item-content">
                <div class="quickInput-menu">
                    <v-form
                        ref="navColorForm"
                        kind="desc"
                    >
                        <color-select
                            v-model="colorData"
                            @submit="()=>{}"
                        />
                        <v-checkbox
                            v-if="channelType !== 1 && hasAdaptThemeColorPrivilege"
                            v-model="colorData.borderAdaptTextColor"
                            label="按钮边框色跟随主题色"
                            class="border-adapt-color-checkbox"
                        />
                    </v-form>
                    <!-- 复用同一个组件有很多问题，直接每个菜单对应一个来处理吧 -->
                    <v-form
                        v-for="(item, index) in menu.list"
                        :key="index"
                        v-show="index === buttonIndex"
                        ref="navMenuForm"
                        kind="desc"
                        @submit="()=>{}"
                    >
                        <menu-name
                            :choseName="item.name"
                            :index="index"
                            :limit="8"
                            :menu="menu"
                            @changeName="changeName"
                            @error="(msg)=>handlerError(msg, 'name', index)"
                        />
                        <menu-msg
                            :action="item.action"
                            :index="index"
                            :meta="item.meta"
                            :channelType="channelType"
                            :menu="menu"
                            @pushMsg="pushMsg"
                            @error="(msg)=>handlerError(msg, 'content', index)"
                        />
                    </v-form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import menuMsg from './components/menuMsg';
import menuName from './components/menuName';
import ColorSelect from './components/color-select';
import { DEFAULT_NAV_MENU } from './constants';
import cloneDeep from 'lodash/cloneDeep';
import { resetMenuSNData } from '../../config';
import { getECommerceStatus } from '@/cgi/getECommerceStatus';

export default {
    components: {
        menuMsg,
        menuName,
        ColorSelect,
    },
    props: {
        value: {
            default() {
                return {
                    enableSwitch: true,
                    color: {},
                    menu: {},
                };
            },
        },
        // 类型：0-webim， 1-小程序插件
        channelType: {
            type: Number,
            default: 0,
        },
        // 当前选择的菜单
        currNavMenuIndex:{
            type: Number,
            default: 0,
        },
        hasAdaptThemeColorPrivilege: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            // 开关
            enableSwitch: true,

            // 默认颜色
            colorData: {
                value: 0,
                color: '#566076',
                borderAdaptTextColor: false,
            },

            // 菜单
            menu: {
                list: [],
            },

            buttonIndex: this.currNavMenuIndex,
            msgErrorDetail: '',
            // 数据是否已经初始化
            isInited: false,
        };
    },
    computed: {
    },
    watch: {
        value: {
            handler(newVal, oldVal) {
                if (JSON.stringify(newVal) === JSON.stringify(oldVal)) return;
                this.parseData();
            },
            deep: true,
        },

        enableSwitch() {
            this.updateNav();
        },

        colorData: {
            handler() {
                this.updateNav();
            },
            deep: true,
        },
        menu: {
            handler() {
                this.updateNav();
            },
            deep: true,
        },

        currNavMenuIndex(val) {
            this.buttonIndex = val;
        },

        /** 按钮变化的时候，检查前一个是否正常 */
        buttonIndex(newVal, oldVal) {
            if (oldVal !== '' && newVal !== oldVal) {
                this.$nextTick(() => {
                    this.validateOne(oldVal);
                });
            }

            this.$emit('update:currNavMenuIndex', newVal);
        },
    },

    async mounted() {
        // 在这里串行请求一下数据，然后再显示UI。
        // 或者下发API会在极短时间内大量请求接口。
        await getECommerceStatus();
        this.isInited = true;
        this.parseData();
    },
    methods: {
        parseData() {
            const { enableSwitch, color = {}, menu = {} } = this.value;

            this.enableSwitch = enableSwitch;

            if (typeof (color.value) !== undefined) {
                this.colorData = cloneDeep(color);
            }

            if (menu.list) {
                this.menu = cloneDeep(menu);
            }
        },

        changeName(val, listIndex) {
            this.menu.list[listIndex].name = val;
        },
        pushMsg(val, action, listIndex) {
            this.menu.list[listIndex].action = action;
            this.menu.list[listIndex].meta = { ...val };
        },

        /** 更新数据 */
        updateNav() {
            console.log('[updateNav]');
            const data = {
                // 默认使用传入的type,如果 value中含有type则会覆盖。
                channelType: this.channelType,
                ...this.value,
                enableSwitch: this.enableSwitch,
                color: cloneDeep(this.colorData),
                menu: cloneDeep(this.menu),
            };

            // 数据检查，防止死循环。
            if (JSON.stringify(data) === JSON.stringify(this.value)) {
                console.log('[updateNav] not change');
                return;
            }

            this.$emit('input', data);
            this.$emit('change', data);
        },

        /** 新增一个 */
        addOne() {
            const menu = cloneDeep(DEFAULT_NAV_MENU);
            const total = this.menu.list.length;
            // 添加一个唯一id，用来做列表的key
            // 注意，对于编辑数据和数据提交，会在 web-tab-detail/config.js 中进行处理。
            this.menu.list.push(menu);
            resetMenuSNData(this.menu.list);
        },
        /** 激活某个按钮的配置，由外部调用 */
        choseOne(index) {
            this.buttonIndex = index;
        },

        /** 删除某个 */
        deleteOne(index) {
            this.menu.list.splice(index, 1);
            resetMenuSNData(this.menu.list);
        },

        /** 错误处理。通过收集表单项中的错误来统一整理处理 */
        handlerError(msg, type, index) {
            return;
            // 之前想按照内部抛出错的方式来收敛错误。
            // 后来发现只要在 index change 的时候校验一下表单就可以了，不需要处理错误事件了
            // 不过有个问题，button的错误效果只有切换后才有效果。

            // if (!this.menu.list[index]) {
            //     return;
            // }
            // if (!this.menu.list[index].errorList) {
            //     this.$set(this.menu.list[index], 'errorList', {});
            // }
            // this.menu.list[index].errorList[type] = msg;
            // // 当errorList中存储的错误提示语内容不为空时，则说明存在错误。
            // if (Object.values(this.menu.list[index].errorList).join('') === '') {
            //     this.$set(this.menu.list[index], 'error', false);
            // } else {
            //     this.$set(this.menu.list[index], 'error', true);
            // }
        },

        /** 判断验证结果是否通过 */
        isFormValid(rs) {
            return rs.join('') === '';
        },

        /** 校验某个表单 */
        async validateOne(index) {
            const f = this.$refs.navMenuForm[index];
            console.log(f);
            if (f) {
                const rs = await f.validate();
                const noError = this.isFormValid(rs);
                console.log('[validateOne]', index, noError);
                this.$set(this.menu.list[index], 'error', !noError);
                return noError;
            } else {
                return true;
            }
        },

        /** 校验全部菜单表单 */
        async validate() {
            // 未启用，不验证
            if (!this.enableSwitch) {
                return true;
            }

            let errorIndexList = [];
            const forms = this.$refs.navMenuForm || [];
            for (let i = 0, n = forms.length; i < n; i++){
                const rs = await forms[i].validate();
                const noError = this.isFormValid(rs);
                this.$set(this.menu.list[i], 'error', !noError);
                // 发生错误，记录位置
                if (!noError) {
                    errorIndexList.push(i);
                }
            }

            if (errorIndexList.length > 0) {
                // 激活第一个报错表单，并返回false。
                this.choseOne(errorIndexList[0]);
                // 抛出事件，后续用来通知card组件
                this.$nextTick(() => {
                    this.$emit('activeErrorMenu', errorIndexList[0]);
                });

                return false;
            }

            return true;
        },
    },
};
</script>

<style lang="less" scoped>
.nav-menu-section{
    padding-top: 0;
    padding-bottom: 0;
}

.border-adapt-color-checkbox {
    margin-bottom: 24px;
    margin-left: 128px;
}
</style>
